import { sheet, setSheet } from './sheet';
import { loadImageFile, type LoadResult } from '../core/fileLoad';
import { distributeImages, type DistributionResult } from '../core/slotPlacement';
import type { FitTarget } from '../types';

export type UploadOutcome = Pick<DistributionResult, 'skippedFilenames' | 'rejectedFilenames' | 'rejectedReasons'>;

export async function uploadFiles(files: File[]): Promise<UploadOutcome> {
  if (files.length === 0) {
    return { skippedFilenames: [], rejectedFilenames: [], rejectedReasons: {} };
  }
  const loadResults: LoadResult[] = await Promise.all(files.map(loadImageFile));
  const result = distributeImages(sheet.slots, loadResults);
  setSheet('slots', result.nextSlots);
  return {
    skippedFilenames: result.skippedFilenames,
    rejectedFilenames: result.rejectedFilenames,
    rejectedReasons: result.rejectedReasons,
  };
}

export async function replaceSlotImage(id: number, file: File): Promise<LoadResult> {
  const result = await loadImageFile(file);
  if (!result.ok) return result;
  const previous = sheet.slots[id]?.image;
  if (previous) URL.revokeObjectURL(previous.objectUrl);
  setSheet('slots', id, 'image', result.image);
  return result;
}

export function clearSlot(id: number): void {
  const previous = sheet.slots[id]?.image;
  if (previous) URL.revokeObjectURL(previous.objectUrl);
  setSheet('slots', id, 'image', null);
}

export function setFitTarget(id: number, target: FitTarget): void {
  setSheet('slots', id, 'fitTarget', target);
}
